import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import features from "features";
import { RootStateInterface } from "reducer";

import ModalWrapper from "components/modals/ModalWrapper/ModalWrapper";
import EditPolygonForm from "scenes/MapPage/components/EditPolygonForm/EditPolygonForm";

import styles from "./edit-polygon-modal.module.scss";

interface EditPolygonModalInterface {
  title?: string;
  isDisableClose?: boolean;
  areaData: any;
  onHide?: () => void;
  isLoading?: boolean;
}

const EditPolygonModal = () => {
  const dispatch = useDispatch();

  const { areaData } = useSelector<
    RootStateInterface,
    EditPolygonModalInterface
  >((state) => state.modal.modalProps);

  useEffect(() => {
    dispatch(features.unitsManager.actions.freezeHistory());
    return () => {
      dispatch(features.unitsManager.actions.unfreezeHistory());
    };
  }, [dispatch]);

  const onModalClose = useCallback(() => {
    dispatch(features.unitsManager.actions.unfreezeHistory());
    dispatch(features.modal.actions.hideModal());
  }, [dispatch]);

  return (
    <ModalWrapper
      className={styles["modal-container"]}
      isDisableClose
      onHide={onModalClose}
    >
      <div className={styles["edit-polygon-modal"]}>
        <div className={styles["form__values-wrapper"]}>
          <EditPolygonForm areaData={areaData} />
        </div>
      </div>
    </ModalWrapper>
  );
};
export default EditPolygonModal;
